import { createRequest, getEndpoint } from "../requestCreator";

export const createProject = createRequest(getEndpoint("projects.sub.create"));
export const getProjects = createRequest(getEndpoint("projects.sub.get"));
export const editProject = createRequest(getEndpoint("projects.sub.update"));
export const deleteProject = createRequest(getEndpoint("projects.sub.delete"));
